module.exports = "<div class=\"modalBackground\" [@backgroundState]=\"state\" (click)=\"hide()\">\n  <div class=\"modalWindow\" [@windowState]=\"state\">\n    <ng-content></ng-content>\n    <p>Click to close</p>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/imageViewer/imageViewer.component.html
// module id = ./src/app/components/imageViewer/imageViewer.component.html
// module chunks = main